import getPresence from '../services/getPresence';

const DEFAULT_TIME_TO_WAIT_TO_BATCH_GET_PRESENCE_REQUESTS = 5000;
let pendingGetPresenceUris: string[] = [];
let batchGetPresenceRequestsTimer = null;

export default function subscribePresence(sipUri: string) {
    if (pendingGetPresenceUris.includes(sipUri)) {
        return;
    }
    pendingGetPresenceUris.push(sipUri);
    if (!batchGetPresenceRequestsTimer) {
        batchGetPresenceRequestsTimer = window.setTimeout(() => {
            batchGetPresenceRequestsTimer = null;
            if (pendingGetPresenceUris.length > 0) {
                getPresence(pendingGetPresenceUris);
                pendingGetPresenceUris = [];
            }
        }, DEFAULT_TIME_TO_WAIT_TO_BATCH_GET_PRESENCE_REQUESTS);
    }
}
